import { css } from 'emotion';

import { colors } from '@cobliteam/base-components/src/styles/colors';

export const sidebarGroup = css`
  &:not(:first-of-type) {
    :before {
      content: "";
      display: block;
      margin: 10px 20px;
      background-color: ${colors.custom.white20};
      height: 1px;
    }
  }

  &:first-of-type {
    margin-top: 8px;
  }

  &:last-of-type {
    margin-bottom: 8px;
  }

  > a,
  > a:hover {
    text-decoration: none;
  }
`;
